import { ChatMessage, ChatMessagesByDate, UnReadMessages } from '@type';
import { dateToUnix } from '@utils';
import { groupDataByDate } from '@utils/chat';

import { initialState, STORE_NAME } from './chat-store.constant';
import { GetType, SetType } from './chat-store.type';

export const setMessageHistory = (set: SetType, get: GetType) => {
  return (messages: ChatMessage[], siteRef: string) => {
    const groupedMessages: ChatMessagesByDate = groupDataByDate(messages);
    set(
      {
        ...get().messages,
        messages: {
          ...get().messages,
          [siteRef]: groupedMessages,
        },
      },
      false,
      `${STORE_NAME}-SET_MESSAGES`
    );
    return messages;
  };
};

export const addMessage = (set: SetType, get: GetType) => {
  return (newMessage: ChatMessage, siteRef: string) => {
    const timestampKey = dateToUnix(newMessage.timestamp.split('T')[0]);
    const chatMessages = get().messages;
    set(
      {
        ...chatMessages,
        messages: {
          ...chatMessages,
          [siteRef]: {
            ...(chatMessages[siteRef] || {}),
            [timestampKey]: [
              ...(chatMessages[siteRef]?.[timestampKey] || []),
              newMessage,
            ],
          },
        },
      },
      false,
      `${STORE_NAME}-ADD_MESSAGES`
    );
    return newMessage;
  };
};

export const setUnReadMessages = (set: SetType) => {
  return (chatMessages: UnReadMessages) => {
    set(
      {
        unReadMessages: {
          ...chatMessages,
        },
      },
      false,
      `${STORE_NAME}-SET_UNREAD_MESSAGES`
    );
  };
};

export const resetChat = (set: SetType) => {
  return () => set(initialState, false, `${STORE_NAME}-RESET_CHAT`);
};
